import { Component, OnInit } from '@angular/core';
import { UserProfileRecord } from '../users/user-profile-record';
import { UserService } from '../users/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})

export class LandingPageComponent implements OnInit {
  private user!: UserProfileRecord;
  isDisplayingError: boolean = false;
  isDisplayingRoleSelection: boolean = false;

  constructor(protected userService: UserService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.user = this.userService.profile;
    
    if(this.user?.userRole) {
      this.redirectToLandingPage();
    } else if(this.user?.availableRoles && this.user?.availableRoles.length > 1) {
      this.isDisplayingRoleSelection = true;
    } else {
      this.isDisplayingError = true;
    }
  }

  selectUserRole(role: string) {
    if(this.user?.availableRoles && this.user?.availableRoles.includes(role)) {
      this.user.userRole = role;
      this.redirectToLandingPage();
    }
  }

  private redirectToLandingPage() {
    let userRole = this.user.userRole;
    if(userRole === 'USAN User') {
      this.router.navigate(['/usan/user-dashboard']);
    } else if(userRole === 'USAN Applicant') {
      this.router.navigate(['/usan/applicant-dashboard']);
    } else if(userRole === 'USAN Org Admin') {
      this.router.navigate(['/usan/orgadmin-dashboard']);
    } else if(userRole === 'USAN Negotiator') {
      this.router.navigate(['/usan/negotiator-dashboard']);
    } else if(userRole === 'USAN AMA Admin') {
      this.router.navigate(['/usan/admin-dashboard']);
    } else {
      this.isDisplayingError = true;
    }
  }

  get userRoles(): string[] {
    return this.user?.availableRoles ? this.user.availableRoles : [];
  }

}
